export default __webpack_public_path__ + "static/media/property-gallery3.86cba419.webp";